import { Box, createStyles, Text } from "@mantine/core";

import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AddButton from "../../../components/AddButton";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import PatientModal from "../../../components/PatientModal";
import PatientTable from "../../../components/PatientTable";
import Topbar from "../../../components/Topbar";
import { getAllFacilitiesModal, getAllFacilityTypes } from "../../../services";
import { getAllPatients } from "../../../services/patient";
import FacilityModal from "./FacilityModal";
import ClientForm from "./ClientForm";
import { useLocation, useNavigate } from "react-router-dom";
import { pageInfoAnalytics } from "../../../config/mixpanelConfig";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import RemainingCounts from "../../../components/RemainingCounts";
import swal from "sweetalert";
import {
  getSubscription,
  upgradePlanAddOn,
} from "../../../services/subscription";
import { isStaff } from "../../../http";
import { getAllPlans } from "../../../services/supportplan";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
  },
  btn: {
    marginLeft: "auto",
    marginTop: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: 10,
    flexWrap: "wrap",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      marginTop: 20,
    },
  },
  formContent: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  mymodal: {
    width: 818,
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  tabContainer: {
    display: "flex",
    minWidth: "260px",
    height: "40px",
  },
  activeTabBg: {
    background: "#fae7be !important",
  },
  activeTab: {
    display: "flex",
    alignItems: "center",
    borderRadius: "50px 0 0 50px",
    background: "#F2F2F2",
    padding: "5px 10px",
    cursor: "pointer",
    "& p": {
      margin: "0",
      fontWeight: "600",
    },
    "& img": {
      width: "24px",
      marginRight: "5px",
    },
  },
  inActiveTab: {
    display: "flex",
    alignItems: "center",
    borderRadius: "0 50px 50px 0",
    background: "#F2F2F2",
    padding: "5px 10px",
    cursor: "pointer",
    "& p": {
      margin: "0",
      fontWeight: "600",
    },
    "& img": {
      width: "24px",
      marginRight: "5px",
    },
  },
  table: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "300px",
  },
  pagination: {
    margin: "1rem 0",
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },
}));
const Patient = (props) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [facility, setFacility] = useState("");
  const { patients, activePatientsCount } = useSelector(
    (state) => state.patient,
  );
  const { profile } = useSelector((state) => {
    return state.profile;
  });
  const [showClientForm, setShowClientForm] = useState(false);
  const [editAll, setEditAll] = useState(false);
  const [selectedTab, setSelectedTab] = useState(true);
  const [remainingClientCount, setRemainingClientCount] = useState(0);
  const [subscription, setSubscription] = useState(null);

  const location = useLocation();

  useEffect(() => {
    if (location?.state?.edit) {
      setShowClientForm(true);
      setEditingPatient(location?.state?.clientDetails);

      const ids = location?.state?.clientDetails?.facilityId?.map((fac) => {
        return fac?.id;
      });
      // setPopulateFacility(ids)
      setUpdateFacility(ids);
    } else {
      setShowClientForm(false);
    }
  }, [location?.state]);

  useEffect(() => {
    getAllFacilitiesModal("active");
    getAllFacilityTypes();
    pageInfoAnalytics("Client Page Viewed", "Client Page");
  }, []);

  useEffect(() => {
    getAllPatients(currentPage, true, selectedTab);
  }, [currentPage, selectedTab]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const [options, setOptions] = useState([]);
  const { allFacilities } = useSelector((state) => state?.facility);
  const [
    facilityModalOpened,
    { open: openFacilityModal, close: closeFacilityModal },
  ] = useDisclosure(false);
  const [editingPatient, setEditingPatient] = useState(null);
  const [populateName, setPopulateName] = useState(null);
  const [populateFacility, setPopulateFacility] = useState(null);
  const [updateFacility, setUpdateFacility] = useState(null);

  useEffect(() => {
    const resp = [];
    allFacilities?.facilities?.map((val) => {
      if (val?.active) {
        resp?.push({
          name: val?.name,
          id: val?.id,
        });
      } else {
        resp?.push({
          name: val?.name,
          id: val?.id,
          disabled: true,
        });
      }
    });
    setOptions(resp);
  }, [allFacilities?.facilities]);

  useEffect(() => {
    if (editingPatient) {
      getAllPlans(editingPatient?.id);
    }
  }, [editingPatient]);

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const subs = await getSubscription();
        setSubscription(subs);
      } catch (error) {
        console.error("Error fetching subscription:", error);
      }
    };

    fetchSubscription();
  }, []);

  useEffect(() => {
    const allowedpatients =
      (profile?.subscription
        ? Number(profile?.subscription?.packageId?.patient)
        : Number(subscription?.packageId?.patient)) +
      (profile?.user?.type === "staff"
        ? Number(profile?.admin?.additionalClient || 0)
        : Number(profile?.user?.additionalClientCount || 0));
    setRemainingClientCount(allowedpatients - activePatientsCount);
  }, [activePatientsCount, profile, subscription]);

  const handleNextClick = (value) => {
    setFacility(value?.map((val) => val?.id));
    closeFacilityModal();
    setPopulateFacility(value);
    setShowClientForm(true);
  };

  const handleBackToClients = () => {
    setShowClientForm(false);
    setEditingPatient(null);
    setFacility("");
    setPopulateName(null);
    setCurrentPage(1);
    setEditAll(false);
    getAllPatients(currentPage, true, selectedTab);
    navigate("/home/patient", { state: { edit: false, disable: false } });
  };

  const handleEditPatient = (patient) => {
    setEditAll(true);
    setShowClientForm(true);
    setEditingPatient(patient);
    setPopulateFacility(patient?.facilityId);

    if (Array.isArray(patient?.facilityId)) {
      const ids = patient?.facilityId?.map((fac) => {
        return fac?.id;
      });

      // setPopulateFacility(ids)
      setUpdateFacility(ids);
    } else {
      // setPopulateFacility([patient?.facilityId?.id])
      setUpdateFacility([patient?.facilityId?.id]);
    }
  };

  const handleOpenModalClick = () => {
    openFacilityModal();
  };

  const handleTabChange = (tab) => {
    setCurrentPage(1);
    setSelectedTab(tab);
  };

  const handleAddClient = async () => {
    if (remainingClientCount <= 0) {
      if (profile?.subscription?.packageId?.name === "Starter") {
        await swal({
          text: `You have reached your quota upgrade subscription to increase limits`,
          icon: "warning",
          dangerMode: true,
        });
      } else {
        const willContinue = await swal({
          title: `Do you wish to continue?`,
          text: `You have exceeded your current plan limit. Additional client will cost $${
            profile?.user?.additionalClientCost ??
            profile?.subscription?.packageId?.additionalClient
          } per month. This charge will be added to your monthly subscription cost`,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: "Cancel",
            confirm: {
              text: "Confirm",
              value: true,
              closeModal: false,
            },
          },
        });

        if (willContinue) {
          await upgradePlanAddOn({ type: "client" });
          swal.close();
          openFacilityModal();
          setPopulateFacility(false);
          setEditingPatient(null);
          setUpdateFacility(null);
          setPopulateName(false);
          setEditAll(false);
        }
      }
    } else {
      openFacilityModal();
      setPopulateFacility(false);
      setEditingPatient(null);
      setUpdateFacility(null);
      setPopulateName(false);
      setEditAll(false);
    }
  };

  return (
    <Box className={classes.content}>
      {showClientForm ? (
        <Box className={classes.formContent}>
          <Topbar
            populateName={populateName}
            initialValues={editingPatient}
            populateFacility={populateFacility}
            backAllClients={handleBackToClients}
            onEditFacilityClick={handleOpenModalClick}
            title={editingPatient ? "Edit Client" : "Add Client"}
          />
          <ClientForm
            opened={opened}
            page={currentPage}
            facility={facility}
            currentPage={currentPage}
            close={handleBackToClients}
            initialValues={editingPatient}
            getAllPatients={getAllPatients}
            setPopulateName={setPopulateName}
            backAllClients={handleBackToClients}
            setShowClientForm={setShowClientForm}
            selectedTab={editAll ? false : location.state}
            buttonLabel={editingPatient ? "Update Client" : "Add Client"}
            tabName={selectedTab}
            populateFacility={populateFacility}
          />
        </Box>
      ) : (
        <>
          <PatientModal
            close={close}
            opened={opened}
            page={currentPage}
            title={"Add New Individual"}
          />
          <AppNavbar title="Client" profile={profile} />
          <Box px={{ base: 12, sm: 20 }}>
            {!isStaff(profile?.user?.role) && (
              <Box mt={20}>
                <RemainingCounts
                  text={"Clients Remaining"}
                  count={remainingClientCount || ""}
                />
              </Box>
            )}

            <Box className={classes.btn}>
              <Box className={classes.tabContainer}>
                <Box
                  className={`${classes.activeTab} ${
                    selectedTab ? classes.activeTabBg : ""
                  }`}
                  onClick={() => handleTabChange(true)}
                >
                  <Text fw={500}>Active</Text>
                </Box>
                <Box
                  className={`${classes.inActiveTab} ${
                    !selectedTab ? classes.activeTabBg : ""
                  }`}
                  onClick={() => handleTabChange(false)}
                >
                  <Text fw={500}>Inactive</Text>
                </Box>
              </Box>
              {profile?.user?.type !== "staff" ||
              (profile?.user?.type === "staff" &&
                profile?.user?.role === "admin") ? (
                <AddButton
                  title={"Add Client"}
                  onClick={() => {
                    handleAddClient();
                    // openFacilityModal();
                    // setPopulateFacility(false);
                    // setEditingPatient(null);
                    // setUpdateFacility(null);
                    // setPopulateName(false);
                    // setEditAll(false);
                  }}
                />
              ) : null}
            </Box>
            <Box className={classes.table}>
              <PatientTable
                onEdit={handleEditPatient}
                selectedTab={selectedTab}
              />
              <CustomPagination
                itemsPerPage={10}
                data={patients?.count}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
              />
            </Box>
          </Box>
        </>
      )}
      <FacilityModal
        options={options}
        onNext={handleNextClick}
        close={closeFacilityModal}
        opened={facilityModalOpened}
        setUpdateFacility={setUpdateFacility}
        setEditingPatient={setEditingPatient}
        setPopulateFacility={setPopulateFacility}
        initialSelectedFacilities={populateFacility}
        editPatient={editingPatient ? editingPatient : false}
        editFacility={editingPatient ? updateFacility : false}
        title={editingPatient ? "Update Facility" : "Select a Facility"}
      />
    </Box>
  );
};

export default Patient;
